import { Link } from 'react-router-dom';
import { updatesList } from '@/mocks/updates';
import { useSeo } from '@/hooks/useSeo';
import PageBanner from '@/components/base/PageBanner';
import Reveal from '@/components/base/Reveal';
import { formatDate } from '@/utils/date';

export default function Updates() {
  useSeo({
    title: '原神版本更新日志 – 原神官方游戏站',
    description: '原神历次版本更新日志汇总，包含新地区、新角色、系统调整与活动开启等详细更新内容。',
    keywords: '原神版本更新,原神更新日志,版本前瞻,版本内容',
    canonicalPath: '/updates',
  });

  return (
    <div>
      <PageBanner
        kicker="VERSION LOG"
        title="版本更新日志"
        subtitle="按时间倒序汇总历次版本更新内容，快速回顾每个版本带来的新地区、新角色与系统调整。"
        crumbs={[{ label: '首页', to: '/' }, { label: '版本更新' }]}
        image={updatesList[0].cover}
      />

      <div className="mx-auto w-full max-w-5xl px-4 py-10 md:px-6 md:py-14 lg:px-8">
        <div className="space-y-6">
          {updatesList.map((item, index) => (
            <Reveal key={item.id} delay={index * 60}>
              <article className="gs-card-hover group grid grid-cols-1 overflow-hidden rounded-xl border border-background-200 bg-background-50 md:grid-cols-5">
                <Link to={`/updates/${item.id}`} className="block cursor-pointer md:col-span-2">
                  <div className="h-44 w-full md:h-full">
                    <img
                      src={item.cover}
                      alt={item.title}
                      title={`${item.title} 原神版本更新`}
                      className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                </Link>
                <div className="flex flex-col justify-between p-5 md:col-span-3">
                  <div>
                    <div className="flex flex-wrap items-center gap-3">
                      <span className="rounded-full bg-primary-500 px-3 py-1 text-xs font-label text-background-50 dark:text-foreground-950">
                        V{item.version}
                      </span>
                      <span className="inline-flex items-center gap-1.5 text-xs text-foreground-500">
                        <i className="ri-calendar-line"></i>
                        {formatDate(item.date)}
                      </span>
                    </div>
                    <h2 className="mt-3 font-heading text-lg font-bold text-foreground-950">
                      <Link to={`/updates/${item.id}`} className="cursor-pointer transition-colors hover:text-primary-700">
                        {item.title}
                      </Link>
                    </h2>
                    <p className="mt-2 line-clamp-2 text-sm text-foreground-600">{item.intro}</p>
                    <div className="mt-3 flex flex-wrap gap-2">
                      {item.sections.map((section) => (
                        <span key={section.heading} className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-[11px] text-secondary-900">
                          {section.heading}
                        </span>
                      ))}
                    </div>
                  </div>
                  <Link
                    to={`/updates/${item.id}`}
                    className="mt-4 inline-flex cursor-pointer items-center gap-1 whitespace-nowrap text-sm font-label text-primary-700 transition-colors hover:text-primary-600"
                  >
                    查看完整更新内容
                    <i className="ri-arrow-right-line"></i>
                  </Link>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}